import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Documento, DocumentiEqualtecResult, DocumentiEqualtecResultObject, AttachmentDto } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';
import { MimetypeService } from '../../services/mimetype.service';
import { ModalService } from '../../services/modal.service';
import { LegalEntityService } from 'src/app/services/legal-entity.service';
import { PresaVisioneModalService } from 'src/app/services/presa-visione-modal.service';

@Component({
  selector: 'app-equaltec-processes',
  templateUrl: './EqualtecProcesses.component.html',
  styleUrls: ['./EqualtecProcesses.component.css']

})
export class EqualtecProcesses implements OnInit {

  public labelNoRecord: boolean = false;
  public isLegalentityTitleInterno: boolean = false;
  public sottoprocessi: string[] = [];
  public openProcess: boolean = true;
  public openGuideline: boolean = true;
  public isExpandedProcess: boolean = false;
  public isExpandedGuideline: boolean = false;
  public isUnderlined: string = "";
  public isTabellaProcessConUnElemento: boolean = false;
  public isTabellaGuidelineConUnElemento: boolean = false;
  public isTabellaProcessRevisionPending: boolean = false;
  public isTabellaGuidelineRevisionPending: boolean = false
  public isTabellaSearchConUnElemento: boolean = false;
  public isTabellaPreferitiConUnElemento: boolean = false;
  public isTabellaLinkConUnElemento: boolean = false;
  public isTabellaPreferitiRevisionPending: boolean = false;
  public isTabellaLinkRevisionPending: boolean = false;
  public isTabellaSearchRevisionPending: boolean = false;
  public isDeafaultRecordFilter: boolean = true;
  public documentiSottoprocessi: boolean = false;
  public tabelleProcessiIdentificazioneDocumento: DocumentiEqualtecResultObject[] = [];
  public tabelleProcessiIdentificazioneDocumentoOrdered: DocumentiEqualtecResultObject[] = [];
  public documentiEqualtecResult: DocumentiEqualtecResult[] = [];
  public documentiEqualtecResultProcess: DocumentiEqualtecResult[] = [];
  public documentiEqualtecResultGuideline: DocumentiEqualtecResult[] = [];
  public documentiEqualtecResultBackup: DocumentiEqualtecResult[] = [];
  public docApertiGuideline: number = 0;
  public docApertiProcess: number = 0;
  public documentiCollegati: Documento[] = [];
  public docApertiPreferiti: number = 0;
  public docApertiLink: number = 0;
  public docApertiSearch: number = 0;
  public isExpandedPreferiti: boolean = false;
  public isExpandedLink: boolean = false;
  public isExpandedSearch: boolean = false;
  public documentsPreferiti: Documento[] = [];
  public srchPubblicazione?: number;
  public srchCommittente?: string;
  public srchPreparatore?: string;
  public srchCreazione?: string;
  public filteredRecords: Documento[] = [];
  public selectedLE: string = "";
  public processoRiferimento: string = "";

  constructor(
    public translate: TranslateService,
    public legalEntityService: LegalEntityService,
    private equaltecService: EqualtecService,
    private documentiEqualtecResultService: CommonService<DocumentiEqualtecResult>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private modalService: ModalService,
    private presaVisioneModalService: PresaVisioneModalService
  ) { }

  private isExternalDocumentType(identificazioneDocumento: string): boolean {
    const documentType = (identificazioneDocumento || '').trim().toLowerCase();
    return documentType === 'process' || documentType === 'guideline';
  }

  get hasProcessDocuments(): boolean {
    return this.documentiEqualtecResultProcess.length > 0;
  }

  get hasGuidelineDocuments(): boolean {
    return this.documentiEqualtecResultGuideline.length > 0;
  }

  private documentBelongsToSubprocess(documento: DocumentiEqualtecResult, nomeSottoprocesso: string): boolean {
    return (documento.nomeSottoprocesso || '')
      .split(',')
      .map(sottoprocesso => sottoprocesso.trim())
      .includes((nomeSottoprocesso || '').trim());
  }

  ngOnInit(): void {
    this.selectedLE = this.equaltecService.selectedLegalEntity;
    this.processoRiferimento = this.equaltecService.nomeProcessoRiferimento;
    this.resetSottoprocessiEdocumenti(this.equaltecService.nomeProcessoRiferimento)
  }

  resetSottoprocessiEdocumenti(nomeProcessoRiferimento: string) {
    this.isLegalentityTitleInterno = false;
    this.labelNoRecord = false;
    this.tabelleProcessiIdentificazioneDocumento = [];
    this.tabelleProcessiIdentificazioneDocumentoOrdered = [];
    this.documentiEqualtecResult = [];
    this.documentiEqualtecResultProcess = [];
    this.documentiEqualtecResultGuideline = [];
    this.documentiEqualtecResultBackup = [];
    this.documentiSottoprocessi = false;
    this.openProcess = true;
    this.openGuideline = true;
    this.sottoprocessi = [];
    this.docApertiGuideline = 0;
    this.docApertiProcess = 0;
    this.isExpandedGuideline = false;
    this.isTabellaGuidelineConUnElemento = false;
    this.isTabellaProcessConUnElemento = false;
    this.isExpandedProcess = false;
    this.isUnderlined = "";
    const url = 'api/rest/caricaSottoprocessiEdocumenti';
    const input = {
      processoRiferimento: nomeProcessoRiferimento,
      filtrolegalEntity: this.equaltecService.selectedLegalEntity
    };  // Attenzione così gestisce un solo filtro. Per più di un filtro usare '#' come separatore filtri
    this.documentiEqualtecResultService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.labelNoRecord = true
        this.documentiEqualtecResult = result as DocumentiEqualtecResult[];
        this.documentiEqualtecResult.forEach(d => {
          if (!this.isExternalDocumentType(d.identificazioneDocumento)) {
            let sottoprocessiList = [];
            sottoprocessiList = (d.nomeSottoprocesso || '').split(',').map(sottoprocesso => sottoprocesso.trim())
            sottoprocessiList.forEach(k => {
              if (k && k != "NA" && !this.sottoprocessi.includes(k)) {
                this.sottoprocessi.push(k);
              }
            })
          }
          d.documentoWSDto.metadatiDtoViewList = d.documentoWSDto.metadatiDtoShortList;
          d.documentoWSDto.apriDettaglio = "Open detail";
          if (this.isExternalDocumentType(d.identificazioneDocumento)) {
            if (d.identificazioneDocumento == "Process") {
              this.documentiEqualtecResultProcess.push(d);
            } else {
              this.documentiEqualtecResultGuideline.push(d);
            }
          }
          this.labelNoRecord = true;
        });
        let total = {}
        this.documentiEqualtecResult.forEach(f => {
          let index = 0;
          let indexCount = 0;
          f.documentoWSDto.metadatiDtoList.forEach(g => {
            if (g.key == "Sottoprocesso") {
              index = indexCount;
            }
            indexCount++;
          })
          f.documentoWSDto.metadatiDtoList.splice(index, 2);
          if (!this.isExternalDocumentType(f.identificazioneDocumento)) {
            if (total[f.identificazioneDocumento] == undefined) {
              total[f.identificazioneDocumento] = []
            }
            total[f.identificazioneDocumento].push(f);
          }
        });
        Object.keys(total).forEach(key => {
          const obj = {
            identificazioneDocumento: key,
            identificazioneDocumentoNum: 0,
            documentiEqualtecResultList: total[key],
            isTabellaAperta: false,
            isTabellaConUnElemento: false,
            isTabellaRevisionPending: false
          };
          this.tabelleProcessiIdentificazioneDocumento.push(obj)
        });
        this.tabelleProcessiIdentificazioneDocumento.forEach(d => {
          d.documentiEqualtecResultList.forEach(doc => {
            if (doc.documentoWSDto.isNewRevisionPending) {
              d.isTabellaRevisionPending = true;
              return;
            }
          })
          let count = 6;
          switch (d.identificazioneDocumento.toLowerCase()) {
            case "procedure":
              d.identificazioneDocumentoNum = 1;
              break;
            case "operative instruction":
              d.identificazioneDocumentoNum = 2;
              break;
            case "working instruction":
              d.identificazioneDocumentoNum = 3;
              break;
            case "template":
              d.identificazioneDocumentoNum = 4;
              break;
            case "record":
              d.identificazioneDocumentoNum = 5;
              break;
            default:
              d.identificazioneDocumentoNum = count;
              break;
          }
          count++;
        });
        this.tabelleProcessiIdentificazioneDocumentoOrdered = this.tabelleProcessiIdentificazioneDocumento.sort((a, b) => {
          return a.identificazioneDocumentoNum - b.identificazioneDocumentoNum
        });
        this.documentiEqualtecResultBackup = this.documentiEqualtecResult;
      }
    }, error => console.error('error on get Processi di Riferimento', error));
  }

  tabMenuAllegato(doc: Documento): void {
    doc.ismenuAllegato = !doc.ismenuAllegato;
    const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
    doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
  }

  tabMenuAllegatoSecondario(doc: any): void {
    this.modalService.open(doc.documentoWSDto.allegatiSecondariDtoList, doc.documentoWSDto.idDocumento);
  }

  documentDetail(apridettaglio: string, codice: string, tipodocumento: string, revisione: string, identificazioneDocumento: string, processOGuideline: string): void {
    if (apridettaglio == "Open detail") {
      this.openDocumentDetail(codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    } else {
      this.closeDocumentDetail(codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    }
  }

  openDocumentDetail(codice: string, tipodocumento: string, revisione: string, identificazioneDocumento: string, tipoDiTabella: string): void {
    switch (tipoDiTabella) {
      case "search": {
        this.docApertiSearch++;
        let documentiAperti = 0;
        this.isExpandedSearch = true;
        this.equaltecService.documents.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaSearchRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.equaltecService.documents.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaSearchRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaSearchConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.equaltecService.documents.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.equaltecService.documents.length && this.equaltecService.documents.length > 1) {
          this.isTabellaSearchConUnElemento = true;
          this.equaltecService.documents.forEach(doc => {
            const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        this.docApertiLink++;
        let documentiAperti = 0;
        this.isExpandedLink = true;
        this.documentiCollegati.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentiCollegati.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaLinkRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaLinkConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = true;
          this.documentiCollegati.forEach(doc => {
            const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      case "process": {
        this.docApertiProcess++;
        let documentiAperti = 0;
        this.isExpandedProcess = true;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.isNewRevisionPending) {
            this.isTabellaProcessRevisionPending = true;
          }
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
            if (this.documentiEqualtecResultProcess.length > 1) {
              const y = { key: '', value: '' }
              doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
              doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaProcessRevisionPending) {
                doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaProcessConUnElemento = true;
            }
            doc.documentoWSDto.apriDettaglio = "Close detail";
          }
        })
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiEqualtecResultProcess.length && this.documentiEqualtecResultProcess.length > 1) {
          this.isTabellaProcessConUnElemento = true;
          this.documentiEqualtecResultProcess.forEach(doc => {
            const spl = this.isTabellaProcessRevisionPending ? 3 : 2;
            doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      case "guideline": {
        this.docApertiGuideline++;
        let documentiAperti = 0;
        this.isExpandedGuideline = true;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.isNewRevisionPending) {
            this.isTabellaGuidelineRevisionPending = true;
          }
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
            if (this.documentiEqualtecResultGuideline.length > 1) {
              const y = { key: '', value: '' }
              doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
              doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaGuidelineRevisionPending) {
                doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaGuidelineConUnElemento = true;
            }
            doc.documentoWSDto.apriDettaglio = "Close detail";
          }
        })
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiEqualtecResultGuideline.length && this.documentiEqualtecResultGuideline.length > 1) {
          this.isTabellaGuidelineConUnElemento = true;
          this.documentiEqualtecResultGuideline.forEach(doc => {
            const spl = this.isTabellaGuidelineRevisionPending ? 3 : 2;
            doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
          })
        } break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          let documentiAperti = 0;
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            tab.isTabellaAperta = true;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.isNewRevisionPending) {
                tab.isTabellaRevisionPending = true;
                return;
              }
            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoList;
                if (tab.documentiEqualtecResultList.length > 1) {
                  const y = { key: '', value: '' }
                  doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
                  doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
                  if (tab.isTabellaRevisionPending) {
                    doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
                  }
                } else {
                  tab.isTabellaConUnElemento = true;
                }
                doc.documentoWSDto.apriDettaglio = "Close detail";
              }
            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiAperti++;
            })
            if (documentiAperti == tab.documentiEqualtecResultList.length && tab.documentiEqualtecResultList.length > 1) {
              tab.isTabellaConUnElemento = true;
              tab.documentiEqualtecResultList.forEach(doc => {
                const spl = tab.isTabellaRevisionPending ? 3 : 2;
                doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
              })
            }
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  closeDocumentDetail(codice: string, tipodocumento: string, revisione: string, identificazioneDocumento: string, tipoDiTabella: string): void {
    switch (tipoDiTabella) {
      case "search": {
        let documentiApertiFull = 0;
        this.equaltecService.documents.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.equaltecService.documents.length && this.equaltecService.documents.length > 1) {
          this.isTabellaSearchConUnElemento = false;
          this.equaltecService.documents.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaSearchRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiSearch--;
        this.equaltecService.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.equaltecService.documents.length > 1) {
              const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiSearch == 0) {
          this.isExpandedSearch = false;
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      case "link": {
        let documentiApertiFull = 0;
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = false;
          this.documentiCollegati.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaLinkRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiLink--;
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documentiCollegati.length > 1) {
              const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiLink == 0) {
          this.isExpandedLink = false;
        }
        break;
      }
      case "process": {
        let documentiApertiFull = 0;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiEqualtecResultProcess.length && this.documentiEqualtecResultProcess.length > 1) {
          this.isTabellaProcessConUnElemento = false;
          this.documentiEqualtecResultProcess.forEach(doc => {
            const y = { key: '', value: '' }
            doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
            doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaProcessRevisionPending) {
              doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiProcess--;
        this.documentiEqualtecResultProcess.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            if (this.documentiEqualtecResultProcess.length > 1) {
              const spl = this.isTabellaProcessRevisionPending ? 3 : 2;
              doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
            }
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
            doc.documentoWSDto.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiProcess == 0) {
          this.isExpandedProcess = false;
        }
        break;
      }
      case "guideline": {
        let documentiApertiFull = 0;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiEqualtecResultGuideline.length && this.documentiEqualtecResultGuideline.length > 1) {
          this.isTabellaGuidelineConUnElemento = false;
          this.documentiEqualtecResultGuideline.forEach(doc => {
            const y = { key: '', value: '' }
            doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
            doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaGuidelineRevisionPending) {
              doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiGuideline--;
        this.documentiEqualtecResultGuideline.forEach(doc => {
          if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
            if (this.documentiEqualtecResultGuideline.length > 1) {
              const spl = this.isTabellaGuidelineRevisionPending ? 3 : 2;
              doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
            }
            doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
            doc.documentoWSDto.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiGuideline == 0) {
          this.isExpandedGuideline = false;
        }
        break;
      }
      case "sottoprocesso": {
        this.tabelleProcessiIdentificazioneDocumentoOrdered.forEach(tab => {
          if (tab.identificazioneDocumento == identificazioneDocumento) {
            let documentiApertiFull = 0;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiApertiFull++;
            })
            if (documentiApertiFull == tab.documentiEqualtecResultList.length && tab.documentiEqualtecResultList.length > 1) {
              tab.isTabellaConUnElemento = false;
              tab.documentiEqualtecResultList.forEach(doc => {
                const y = { key: '', value: '' }
                doc.documentoWSDto.metadatiDtoViewList.splice(3, 0, y);
                doc.documentoWSDto.metadatiDtoViewList.splice(4, 0, y);
                if (tab.isTabellaRevisionPending) {
                  doc.documentoWSDto.metadatiDtoViewList.splice(5, 0, y);
                }
              })
            }
            let documentiAperti = 0;
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.codice == codice && doc.documentoWSDto.tipoDocumento == tipodocumento && doc.documentoWSDto.revisione == revisione) {
                if (tab.documentiEqualtecResultList.length > 1) {
                  const spl = tab.isTabellaRevisionPending ? 3 : 2;
                  doc.documentoWSDto.metadatiDtoViewList.splice(3, spl);
                }
                doc.documentoWSDto.metadatiDtoViewList = doc.documentoWSDto.metadatiDtoShortList;
                doc.documentoWSDto.apriDettaglio = "Open detail";
              }
            })
            tab.documentiEqualtecResultList.forEach(doc => {
              if (doc.documentoWSDto.apriDettaglio == "Close detail")
                documentiAperti++;
            })
            if (documentiAperti == 0) {
              tab.isTabellaAperta = false;
            }
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  }

  visualizzaSottoprocessiEdocumenti(nomeSottoprocesso: string) {
    this.documentiSottoprocessi = true;
    this.tabelleProcessiIdentificazioneDocumento = [];
    this.isUnderlined = nomeSottoprocesso;
    this.documentiEqualtecResult = this.documentiEqualtecResultBackup;
    this.documentiEqualtecResult = this.documentiEqualtecResult.filter(d => {
      return !this.isExternalDocumentType(d.identificazioneDocumento) && this.documentBelongsToSubprocess(d, nomeSottoprocesso);
    });
    let total = {}
    this.documentiEqualtecResult.forEach(f => {
      if (!total[f.identificazioneDocumento]) {
        total[f.identificazioneDocumento] = []
      }
      if (f.documentoWSDto.metadatiDtoList.length == 8) {
        f.documentoWSDto.metadatiDtoViewList.splice(3, 2);
      }
      total[f.identificazioneDocumento].push(f);
    });
    Object.keys(total).forEach(key => {
      const obj = {
        identificazioneDocumento: key,
        identificazioneDocumentoNum: 0,
        documentiEqualtecResultList: total[key],
        isTabellaAperta: false,
        isTabellaConUnElemento: false,
        isTabellaRevisionPending: false
      };
      this.tabelleProcessiIdentificazioneDocumento.push(obj)
    });
    this.tabelleProcessiIdentificazioneDocumento.forEach(f => {
      f.documentiEqualtecResultList.forEach(d => {
        if (d.documentoWSDto.apriDettaglio == "Close detail") {
          d.documentoWSDto.metadatiDtoViewList = d.documentoWSDto.metadatiDtoShortList;
          d.documentoWSDto.apriDettaglio = "Open detail";
        }
      })
    })
    this.tabelleProcessiIdentificazioneDocumento.forEach(d => {
      d.documentiEqualtecResultList.forEach(doc => {
        if (doc.documentoWSDto.isNewRevisionPending) {
          d.isTabellaRevisionPending = true;
          return;
        }
      })
      let count = 6;
      switch (d.identificazioneDocumento.toLowerCase()) {
        case "procedure":
          d.identificazioneDocumentoNum = 1;
          break;
        case "operative instruction":
          d.identificazioneDocumentoNum = 2;
          break;
        case "working instruction":
          d.identificazioneDocumentoNum = 3;
          break;
        case "template":
          d.identificazioneDocumentoNum = 4;
          break;
        case "record":
          d.identificazioneDocumentoNum = 5;
          break;
        default:
          d.identificazioneDocumentoNum = count;
          break;
      }
      count++;
    });
    this.tabelleProcessiIdentificazioneDocumentoOrdered = this.tabelleProcessiIdentificazioneDocumento.sort((a, b) => {
      return a.identificazioneDocumentoNum - b.identificazioneDocumentoNum;
    });
  }

  getArcadocAttach(item: AttachmentDto, iddocumento: number, download: boolean) {
    const url = 'api/rest/GetAttachment';
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download,
        needPresaVisione: this.isComplianceLegalEntity()
      }
    };
    this.fileServer.getData(url, params, false).toPromise()
      .then(res => {
        const attachment: AttachmentDto = res as AttachmentDto;
        if (this.isComplianceLegalEntity() && !attachment.presaVisione) {
          this.presaVisioneModalService.open(params.params.idDocument, params.params.idAllegato, params.params.download, params.params.fileName);
          return;
        }

        if (attachment.presaVisione && !this.hasAttachmentData(attachment)) {
          alert("Impossibile recuperare l'allegato!");
          return;
        }

        this.openAttachment(attachment, download);
      });
  }

  private dataURIToBlob(dataURI: any, mimeString: string): Promise<Blob> {
    return new Promise(resolve => {
      const binStr = atob(dataURI);
      const len = binStr.length;
      const arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      resolve(new Blob([arr], { type: mimeString }));
    });
  }

  private isComplianceLegalEntity(): boolean {
    const legalEntity = (this.equaltecService.selectedLegalEntity || this.selectedLE || '').trim().toLowerCase();
    return legalEntity === 'compliance';
  }

  private openAttachment(attachment: AttachmentDto, download: boolean): void {
    const fileName = attachment.nomeFile;
    const ext = fileName.split('.').pop() || '';
    const downloadLink = document.createElement("a");

    this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
      .then(b => {
        const blob: Blob = b as Blob;
        const url = URL.createObjectURL(blob);

        if (download) {
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
          window.open(url, '_blank');
        }
      });
  }

  private hasAttachmentData(attachment: AttachmentDto): boolean {
    return attachment != null  && typeof attachment.data === 'string'  && attachment.data.trim() !== '';
  }

}
